import {
	ExternalTicket,
	ExternalTicketAdminDraft,
	ExternalTicketAdminFilters,
	ExternalTicketAdminOptions,
	ExternalTicketAttachment,
	ExternalTicketComment,
	ExternalTicketDraft,
	ExternalTicketOptions,
	ExternalTicketPagedResult,
} from '../Types/externalTicket';
import { get, getQSFromObject, post, postForm, put } from './common';

const endpoint = 'api/v3/external-tickets';

const listQuery = (search: string, page: number, pageSize: number) =>
	getQSFromObject({ search, page, pageSize });

export const getMyExternalTickets = (search: string, page: number, pageSize: number) =>
	get<ExternalTicketPagedResult>(`${endpoint}/mine?${listQuery(search, page, pageSize)}`);

export const getMyExternalTicket = (ticketId: number) => get<ExternalTicket>(`${endpoint}/mine/${ticketId}`);

export const createExternalTicket = (draft: ExternalTicketDraft) => post<ExternalTicket>(`${endpoint}/mine`, draft);

export const updateMyExternalTicket = (ticketId: number, draft: ExternalTicketDraft) =>
	put<ExternalTicket>(`${endpoint}/mine/${ticketId}`, draft);

export const addMyExternalTicketComment = (ticketId: number, text: string) =>
	post<ExternalTicketComment>(`${endpoint}/mine/${ticketId}/comments`, { text });

export const getMyExternalTicketAttachments = (ticketId: number) =>
	get<ExternalTicketAttachment[]>(`${endpoint}/mine/${ticketId}/attachments`);

export const uploadMyExternalTicketAttachment = (ticketId: number, file: File) =>
	uploadExternalTicketAttachment(`${endpoint}/mine/${ticketId}/attachments`, file);

export const getExternalTicketOptions = () => get<ExternalTicketOptions>(`${endpoint}/options`);

export const getAdminExternalTickets = (search: string, page: number, pageSize: number, filters: ExternalTicketAdminFilters) =>
	get<ExternalTicketPagedResult>(`${endpoint}/admin?${getQSFromObject({ search, page, pageSize, ...filters })}`);

export const getAdminExternalTicket = (ticketId: number) => get<ExternalTicket>(`${endpoint}/admin/${ticketId}`);

export const updateAdminExternalTicket = (ticketId: number, draft: ExternalTicketAdminDraft) =>
	put<ExternalTicket>(`${endpoint}/admin/${ticketId}`, draft);

export const addAdminExternalTicketComment = (ticketId: number, text: string) =>
	post<ExternalTicketComment>(`${endpoint}/admin/${ticketId}/comments`, { text });

export const getAdminExternalTicketAttachments = (ticketId: number) =>
	get<ExternalTicketAttachment[]>(`${endpoint}/admin/${ticketId}/attachments`);

export const uploadAdminExternalTicketAttachment = (ticketId: number, file: File) =>
	uploadExternalTicketAttachment(`${endpoint}/admin/${ticketId}/attachments`, file);

export const submitExternalTicket = (ticketId: number, projectId: number, milestoneId?: number) =>
	post<ExternalTicket>(`${endpoint}/admin/${ticketId}/submit`, { projectId, milestoneId });

export const closeExternalTicket = (ticketId: number) =>
	post<ExternalTicket>(`${endpoint}/admin/${ticketId}/close`, {});

export const getAdminExternalTicketOptions = () => get<ExternalTicketAdminOptions>(`${endpoint}/admin/options`);

const uploadExternalTicketAttachment = (url: string, file: File) => {
	const data = new FormData();
	data.append('file', file, file.name);
	return postForm<ExternalTicketAttachment[]>(url, data);
};
